'use client'; // Add this if you're using Next.js 13+ app folder (optional)

import { useEffect, useState } from 'react';

// Direct imports of JSON
import glossaryHRMS from '@/data/jsons/GlossaryHRMS.json';
import glossaryCRM from '@/data/jsons/GlossaryCRM.json';
import glossaryWhatsapp from '@/data/jsons/GlossaryWhatsapp.json';
import glossaryCampaign from '@/data/jsons/GlossaryCampaign.json';
import glossaryPayroll from '@/data/jsons/GlossaryPayroll.json';
import glossaryPMS from '@/data/jsons/GlossaryPMS.json';

// Types
type GlossaryItem = {
    title: string;
    slug: string;
    description: string;
    keywords: string[];
    img: string;
};

// Helper function to shuffle array
function shuffleArray<T>(array: T[]): T[] {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}

const GlossaryQuickLinks = () => {
    const [glossaries, setGlossaries] = useState<GlossaryItem[]>([]);

    useEffect(() => {
        // Merge all imported glossary arrays
        const allGlossaryItems: GlossaryItem[] = [
            ...glossaryHRMS,
            ...glossaryCRM,
            ...glossaryWhatsapp,
            ...glossaryCampaign,
            ...glossaryPayroll,
            ...glossaryPMS,
        ];

        // Shuffle and pick 6
        const randomGlossaries = shuffleArray(allGlossaryItems).slice(0, 6);

        setGlossaries(randomGlossaries);
    }, []);

    // if (glossaries.length === 0) {
    //     return <div>Loading...</div>; // simple loading
    // }

    return (

        <section className="pt-20 pb-20">
            <div className="container">
                <div className="row mb-50 mb-sm-50">
                    <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center">
                        <h2 className="section-title-small mb-20">
                            Related Glossary
                        </h2>
                        <p className="text-gray mb-0">
                            Enjoy a range of benefits designed to help you thrive both professionally and personally.
                        </p>
                    </div>
                </div>
                <div className="row mt-n30">
                    {glossaries.map((topic, index) => (
                        <div
                            key={index}
                            className="post-prev-2-title col-md-4 text-lg transform scale-95 transition-transform duration-300 ease-in-out hover:scale-100 hover:shadow-lg"
                        >
                            <div className="border border-black p-2 rounded-md mt-20">
                                <h3 className="text-center justify-center mt-20 md:text-md" style={{ fontSize: "20px" }}>
                                    <a href={`/glossary/${topic.slug}/`}>
                                        {topic.title || 'Untitled'}
                                    </a>
                                </h3>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default GlossaryQuickLinks;
